import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=3f00556d&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=3f00556d&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00556d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f00556d')) {
      api.createRecord('3f00556d', component.options)
    } else {
      api.reload('3f00556d', component.options)
    }
    module.hot.accept("./TaskDetail.vue?vue&type=template&id=3f00556d&scoped=true", function () {
      api.rerender('3f00556d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/taskDetail/TaskDetail.vue"
export default component.exports